// SwitchIOS.jsx
import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const CustomSwitch = withStyles(() => ({
   root: {
      width: 'var(--switch-width, 80px)',
      height: 26,
      padding: 0,
      display: 'flex',
   },
   switchBase: {
      padding: 2,
      '&$checked': {
         transform: 'translateX(calc(var(--switch-width, 80px) - 26px))',
         color: '#fff',
         '& + $track': {
            backgroundColor: '#65C466',
            opacity: 1,
            '&::before': {
               visibility: 'visible', // แสดง active
            },
            '&::after': {
               visibility: 'hidden', // ซ่อน inactive
            },
         },
      },
   },
   thumb: {
      width: 22,
      height: 22,
      boxShadow: '0 2px 4px 0 rgba(0, 35, 11, 0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 10,
      fontWeight: 'bold',
      color: '#fff',
   },
   track: {
      borderRadius: 17,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      position: 'relative',
      '&::before, &::after': {
         content: '""',
         position: 'absolute',
         top: '50%',
         transform: 'translateY(-50%)',
         fontSize: 18,
      },
      '&::before': {
         content: 'var(--active-text)',
         left: 8,
         color: '#FFFFFF',
         visibility: 'hidden', // ซ่อน active เริ่มต้น
      },
      '&::after': {
         content: 'var(--inactive-text)',
         right: 8,
         color: '#A29FAC',
         visibility: 'visible', // แสดง inactive เริ่มต้น
      },
   },
   input: {
      left: '-180%',
      width: '600%',
   },
   checked: {},
}))(Switch);

export default function SwitchIOS({
   onChange,
   checked,
   activeText = 'Active',
   inactiveText = 'Inactive',
   width = '80px',
}) {
   const handleChange = (event) => {
      if (onChange) {
         onChange(event.target.checked);
      }
   };

   return (
      <div
         style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            '--active-text': `"${activeText}"`,
            '--inactive-text': `"${inactiveText}"`,
            '--switch-width': width,
         }}
      >
         <CustomSwitch checked={checked} onChange={handleChange} />
      </div>
   );
}
